import Component from '../site/Component';

/**
 * Component for Surprise Me! module.
 */
export default class SurpriseMe extends Component {

  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.populateModule();
    this.element.parentNode.querySelector(this.elements.loadMore)
      .addEventListener('click', () => {
        this.populateModule();
      });
  }

  populateModule() {
    // Ensure we have at least 3 to show.
    if (window.surpriseMeBooks && 3 <= window.surpriseMeBooks.length) {
      // Select 3 random books.
      const books = SurpriseMe.pickRandomBooks(window.surpriseMeBooks, 3);
      // Build HTML nodes for the books.
      const booksMarkup = books.map(SurpriseMe.buildMarkup);
      // Write the HTML.
      this.element.innerHTML = booksMarkup.join('\n');
    }
  }

  static buildMarkup(book) {
    return `
      <div class="magic-8__result">
        <div class="magic-8__cover">
          <a href="${book.link}"
            data-type="link-event"
            data-category="Surprise Me"
            data-action="Title Click"
            data-label="${book.title}"
          >${book.image}</a>
        </div>
        <div class="magic-8__description">
          <div class="magic-8__description-text">
            <h3>
              <a alt="${book.title}" href="${book.link}"
                data-type="link-event"
                data-category="Surprise Me"
                data-action="Title Click"
                data-label="${book.title}"
              >${book.title}</a>
            </h3>
            <div>${book.summary}</div>
          </div>
        </div>
      </div>
    `;
  }

  static pickRandomBooks(books, num) {
    const shuffledBooks = shuffleArray(books);
    return shuffledBooks.slice(0, num);
  }
}

function shuffleArray(items) {
  let top = items.length;
  const newItems = items;

  if (top) {
    while (--top) { // eslint-disable-line no-plusplus,space-unary-ops
      const current = Math.floor(Math.random() * (top + 1));
      const tmp = newItems[current];
      newItems[current] = newItems[top];
      newItems[top] = tmp;
    }
  }

  return newItems;
}
